<div class="editor-switcher">
  <button
    type="button"
    class="editor-switcher__option"
    [class.active]="selectedValue() === 'editor'"
    (click)="onEditorChange('editor')"
    title="Text-Editor"
  >
    <i class="bi bi-pencil-square"></i>
    <span class="editor-switcher__label">Text</span>
  </button>
  
  <button
    type="button"
    class="editor-switcher__option"
    [class.active]="selectedValue() === 'pdf'"
    (click)="onEditorChange('pdf')"
    title="PDF-Ansicht"
  >
    <i class="bi bi-filetype-pdf"></i>
    <span class="editor-switcher__label">PDF</span>
  </button>
</div>
